const regions = {
  getStates: () => `/regions/states`,
  getCounties: () => `/regions/counties`,
  getZipCodes: () => `/regions/zip-codes`,
  getCountyBoundaries: () => `/regions/counties/boundaries`,
  assignFieldRepManagerToStates: () => "/regions/states/field-rep-manager",
  assignFieldRepManagerToCounties: () => "/regions/counties/field-rep-manager",
  assignAppraiserManagerToStates: () => "/regions/states/appraiser-manager",
  assignAppraiserManagerToCounties: () => "/regions/counties/appraiser-manager",
  assignLenderLogisticsManagerToStates: () => "/regions/states/lender-logistics-manager",
  assignLenderLogisticsManagerToCounties: () => "/regions/counties/lender-logistics-manager",
  updateCounty: (serviceRegionId, countyId) => `/regions/${serviceRegionId}/county/${countyId}`,
  getCountiesForServiceRegion: (id) => `/regions/service-regions/${id}/counties`,
  getCountyPostalCodes: () => `/regions/county-postal-codes`,
};

export default regions;